import BorderBox from "../../../../components/borderbox";
import JsonRawContainer from "../../../../components/json_raw_container";
import h from "../../../../core/createElement";
import popupAlerts from "../../../../core/popupAlerts";

export default function JsonBodyBox({ shared = {}, name = "json", onChangeObject }) {
    const inner_shared = {};

    const validate_json = (v) => {
        if (!v) {
            popupAlerts.warning("Sintaxe json inválida!");
            inner_shared.json_raw_field.invalid(true);
            return null;
        };
        onChangeObject && onChangeObject(v);
    };

    shared[name] = {
        patch_value: (obj = {}) => {
            inner_shared.json_raw_field.setValue(obj);
            return obj;
        }
    };

    return (
        <BorderBox title="Json Object/Array" contentClass="json-field" >
            <JsonRawContainer name="json_raw_field" shared={inner_shared} onChange={validate_json} />
        </BorderBox>
    );
};